import React, { createContext, useState, useEffect } from 'react';

// Erstelle den Kontext
export const AuthContext = createContext();

// Erstelle den Provider
export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    token: null,
    user: null,
  });

  // Beim Laden die Token und User aus dem localStorage holen
  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (token && user) {
      try {
        setAuth({ token, user: JSON.parse(user) });
      } catch (e) {
        console.error('Fehler beim Parsen von user:', e);
        setAuth({ token: null, user: null });
      }
    }
  }, []);

  // Login-Funktion
  const login = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setAuth({ token, user });
  };

  // Logout-Funktion
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setAuth({ token: null, user: null });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
